import React from 'react';
import Team from '../components/Team';

const TeamPage = () => {
  return (
    <div className="pt-20">
      <Team />
    </div>
  );
};

export default TeamPage;